// extracted by mini-css-extract-plugin
export var grid = "_x-0";
export var span1 = "_x-2";
export var span10 = "_x-b";
export var span10L = "_x-z";
export var span10M = "_x-n";
export var span10Xl = "_x-1b";
export var span11 = "_x-c";
export var span11L = "_x-10";
export var span11M = "_x-o";
export var span11Xl = "_x-1c";
export var span12 = "_x-d";
export var span12L = "_x-11";
export var span12M = "_x-p";
export var span12Xl = "_x-1d";
export var span1L = "_x-q";
export var span1M = "_x-e";
export var span1Xl = "_x-12";
export var span2 = "_x-3";
export var span2L = "_x-r";
export var span2M = "_x-f";
export var span2Xl = "_x-13";
export var span3 = "_x-4";
export var span3L = "_x-s";
export var span3M = "_x-g";
export var span3Xl = "_x-14";
export var span4 = "_x-5";
export var span4L = "_x-t";
export var span4M = "_x-h";
export var span4Xl = "_x-15";
export var span5 = "_x-6";
export var span5L = "_x-u";
export var span5M = "_x-i";
export var span5Xl = "_x-16";
export var span6 = "_x-7";
export var span6L = "_x-v";
export var span6M = "_x-j";
export var span6Xl = "_x-17";
export var span7 = "_x-8";
export var span7L = "_x-w";
export var span7M = "_x-k";
export var span7Xl = "_x-18";
export var span8 = "_x-9";
export var span8L = "_x-x";
export var span8M = "_x-l";
export var span8Xl = "_x-19";
export var span9 = "_x-a";
export var span9L = "_x-y";
export var span9M = "_x-m";
export var span9Xl = "_x-1a";
export var stretch = "_x-1";